export default (state = {}, action) => {
  if (action.type === 'BROADCAST_SET_ATTENDEE_CONNECTION_METRICS') {
    const { attendeeId, metrics } = action.payload;
    const next = { ...state };
    next[attendeeId] = metrics;
    return next;
  }

  return state;
};
